import React, { createContext } from "react";
import "./MicroPendingTableRow.css";
import { Form } from "antd";

export const FormContext = createContext(null);

function MicroPendingTableRow({
  record, index, checkRowDisabled, ...antdProps
}) {
  if (!record) { // recheck message row
    return <tr {...antdProps} />; // eslint-disable-line react/jsx-props-no-spreading
  }

  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <FormContext.Provider value={form}>
        <tr
          {...antdProps} // eslint-disable-line react/jsx-props-no-spreading
          className={`${antdProps.className} MicroPending__Row${checkRowDisabled(record) ? "--disabled" : ""}${record.recheck ? "--recheck" : ""}`}
        />
      </FormContext.Provider>
    </Form>

  );
}

export default MicroPendingTableRow;
